import React from "react";
import {
  useTheme,
  Statistics,
  IconPanel,
  Grid,
  Typography,
  Chip,
} from "@tiny/components";
import { SuppressionView } from "@tiny/api";
import Group from "@tiny/icons/generated/Group";
import InfoOutline from "@tiny/icons/generated/InfoOutline";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";

type SuppressionDetailsStatisticsProps = {
  suppressionDetails?: SuppressionView;
};

function SuppressionDetailsStatistics(
  props: SuppressionDetailsStatisticsProps
) {
  const { suppressionDetails } = props;

  const theme = useTheme();
  const { mdUp, lgUp } = useBreakpoints();

  const getSuppressionTitle = (type?: string) => {
    switch (type) {
      case "EMAIL":
        return "This list contains email addresses to prevent further communication.";
      case "MD5":
        return "This list contains email addresses stored as MD5 hashes for privacy in suppression.";
      case "SHA256":
        return "This list contains email addresses stored as SHA-256 hashes for enhanced security in suppression.";
      default:
        return "Unknown suppression type.";
    }
  };

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
      <Grid item xs={12} sm={6} md={3}>
        <IconPanel
          icon={<Group />}
          color={theme.palette.primary.main}
          hasBorderRadius={mdUp}
        >
          <Statistics
            value={
              formatNumber(suppressionDetails?.suppressedCount) || undefined
            }
            title="Total suppressed emails"
            info="Global suppression emails are applicable to all campaigns. To remove a particular global suppression, mark them as local from the edit button in the list."
          />
        </IconPanel>
      </Grid>
      <Grid item xs={12} sm={6} md={9}>
        <IconPanel
          icon={<InfoOutline />}
          color={theme.palette.primary.main}
          height={"100%"}
        >
          <Typography
            variant="body3"
            color="grey"
            tone={700}
            component="div"
            mt={1}
          >
            {getSuppressionTitle(suppressionDetails?.type)}
          </Typography>
          <Chip label={suppressionDetails?.type} size="small" />
        </IconPanel>
      </Grid>
    </Grid>
  );
}

export default SuppressionDetailsStatistics;
